import React from 'react';

export default function SectionHeading({ eyebrow, title, subtitle, align = 'center', light = false }) {
  return (
    <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
      {eyebrow && (
        <div className={`divider-ornate mb-4 ${align === 'center' ? '' : 'justify-start'}`} style={align !== 'center' ? { justifyContent: 'flex-start' } : {}}>
          <span className="text-xs tracking-[0.35em] uppercase font-medium">{eyebrow}</span>
        </div>
      )}
      <h2 className={`font-serif-display text-3xl md:text-5xl leading-[1.1] ${light ? 'text-white' : 'text-ink'}`}>{title}</h2>
      {subtitle && (
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? 'text-white/75' : 'text-ink/65'}`}>{subtitle}</p>
      )}
    </div>
  );
}
